/**
 * Per-session query-logs hook (TanStack Query).
 *
 * Fetches GET /query-logs?session_id=… — one row per assistant turn,
 * recording which services/tools were called. Each row's `id` === the
 * message id, so the admin Session Monitor merges these onto the session's
 * messages to show tools-fired per message.
 *
 * The session filter is what selects the session gate server-side; the rows
 * themselves are the same records an admin reads unfiltered.
 */

import { useAuthenticatedQuery } from '@/hooks/useAuthenticatedQuery';
import { sessionsApi } from '@/api/endpoints/sessions';
import type { SessionTraceResponse } from '@/api/types_session';
import { ApiError } from '@/api/client';

export function useSessionQueryLogs(sessionId: string | null) {
  return useAuthenticatedQuery<SessionTraceResponse[], ApiError>({
    queryKey: ['session', sessionId, 'query-logs'],
    queryFn: () => sessionsApi.traces(sessionId as string).then((page) => page.items),
    enabled: !!sessionId,
  });
}
